/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_No_Results_FoundInputs */



/**
* | output |
* | --- |
* | "No Results Found" |
*
* @param {Find_Replace_No_Results_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_no_results_found = /** @type {((inputs?: Find_Replace_No_Results_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_No_Results_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun resultat trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ergebnisse gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun risultato trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron resultados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("結果が見つかりませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई परिणाम नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum resultado encontrado")
	return /** @type {LocalizedString} */ ("No Results Found")
});